import { useHistory } from "react-router-dom";

import { TeamMemberForm } from "../../TeamMemberForm";
import { TEAM_MEMBERS_QUERY } from "../../TeamMembers/TeamMembersQuery";

import { useTeamMemberCreateMutation } from "./TeamMemberCreateMutation";
import type { TeamMemberCreateVariables } from "./TeamMemberCreateMutation";

const TeamMemberNew = () => {
  const { push } = useHistory();
  const [createTeamMember] = useTeamMemberCreateMutation({
    refetchQueries: [{ query: TEAM_MEMBERS_QUERY }],
  });

  const handleSave = async (teamMember: TeamMemberCreateVariables) => {
    const { data } = await createTeamMember({ variables: teamMember });

    if (data?.createTeamMember?.teamMember?.slug) {
      push(`/team_members/${data.createTeamMember.teamMember.slug}`);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <TeamMemberForm onCreate={handleSave} />
      </div>
    </div>
  );
};

export { TeamMemberNew };
